import React from 'react';
import Layout from '../../components/Layout';
import { Link } from 'react-router-dom';

const CreateHomePage = () => (
  <Layout>
    <section className='hero is-secondary is-bold'>
      <div className='hero-body'>
        <div className='container'>
          <div className='columns is-vcentered'>

            <div className='column is-12-mobile is-6' >
            <div className='section'>
                <h1 className='title has-text-weight-semibold is-size-3'>
                  Lorem ipsum blah
                </h1>
                <h2 className='is-size-5'>
                 asdsd
                </h2>

                <div className='is-10-mobile is-12'>
                  asd
                </div>
              </div>
            </div>

            <div className="column is-6 is-flex is-horizontal-center is-hidden-mobile">
             
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className='section section--gradient is-medium'>
      <div className="container">
        <p className="title has-text-centered mb-1 has-text-grey">
            <Link to="/create/birthday">Birthday</Link>
        </p>
      </div>
    </section>

  </Layout>

);

export default CreateHomePage;